// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b079545a","455":"a1484f39","977":"68c5f5f9"}[chunkId] + ".chunk.js";
};